export { SuiDatepickerModule, DatepickerMode } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/datepicker/public.js
// module id = 1102
// module chunks = 0